<template lang="pug">
	div#app(:class="classes")
		reader-view
</template>

<script>
import ReaderView from '@/views/ReaderView'
import '@custom-media/ksv-liveticker-shared/src/style/fonts.scss'
import '@fortawesome/fontawesome-pro/css/fontawesome.css'
import '@fortawesome/fontawesome-pro/css/solid.css'
import '@fortawesome/fontawesome-pro/css/brands.css'
export default {
	components: {
		ReaderView
	},
	computed: {
		classes () {
			if (process && process.env && process.env.VUE_APP_CLASS) {
				return process.env.VUE_APP_CLASS
			} else {
				return null
			}
		}
	}
}
</script>

<style lang="scss">
@import "@/assets/scss/bulma-customized.scss";
body {
	font-family: 'Bunday Sans', sans-serif;
}
a {
	color: $primary;
}
section .title {
	display: inline-block;
	padding: 0.4em 0.7em;
	background: $primary;
	color: white;
	text-transform: uppercase;
}

.image img {
	height: auto;
	width: auto;
	max-height: 100%;
	max-width: 100%;
	margin: 0 auto;
}

.powered-by {
	margin-top: 1em;
	display: flex;
	justify-content: center;
	align-items: center;
	a {
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			margin-left: 0.5em;
		}
	}
}

#app.is-staging header .header-background {
	background-color: #ED5565;
}

</style>
